import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../types/material';

export const mapProductToAnalyticsEcommerceItem = (params: {
  product: ProductSearchMaterial;
  itemListId?: string;
  itemListName?: string;
  index?: number;
}) => {
  const { product, itemListId, itemListName, index } = params;

  const colorway = product.ssFacetColorFilter?.find(
    (color) => color.image_url === product.thumbnailImageUrl?.split('?')?.[0],
  );
  const itemColor = colorway != null ? colorway?.color_name : null;
  const finishesColor = product?.configData?.color;

  return {
    item_id: product.sku,
    item_name: product.name,
    item_brand: product.manufacturer,
    ...getAnalyticsItemCategoriesByTaxonomy(product.taxonomy),
    index: product.gridIndex ?? product.index ?? index,
    price: 0,
    quantity: 1,
    item_list_id: itemListId,
    item_list_name: itemListName,
    item_variant: finishesColor ?? itemColor ?? '',
  };
};
